import {ChangeDetectorRef, Component, OnInit} from "@angular/core";
import {NotificationService} from "~/app/core/notification.service";
import {ApiService} from "~/app/core/api.service";
import * as Log from "~/app/core/log";
import {MapService} from "~/app/core/maps.service";
import {HomeComponent} from "~/app/components/home/home.component";
import {getElement} from "ionicons/dist/types/stencil-public-runtime";
import {OfferInfo} from "~/app/core/model/offer-info";
import {AddressInfo} from "~/app/core/model/address-info";
import {add} from "ionicons/icons";
import {LocationInfo} from "~/app/core/model/location-info";
import {LocationService} from "~/app/core/location.service";
import {StorageService} from "~/app/core/storage.service";
import {OfferSearch} from "~/app/core/model/offer-search";

@Component({
    selector: "map",
    templateUrl: "./map.component.html",
    styleUrls: ["./map.component.scss"]
})
export class MapComponent implements OnInit {
  map;
  selectedOffer: OfferInfo;
  selectedLocation: AddressInfo;
  selectedLocationDistance: number;
  currentInfo: google.maps.InfoWindow;
  latitude: number;
  longitude: number;
  markers = [];
  location: boolean;
  radius: number;
  zipCode: string;

  constructor(
    private readonly api: ApiService,
    private readonly cd: ChangeDetectorRef,
    private readonly mapService: MapService,
    private homeComponent: HomeComponent,
    private locationService: LocationService,
    private readonly storageService: StorageService)
  {
  }

  ngOnInit(): void {
    let offerSearch: OfferSearch = this.storageService.loadOfferSearch();
    this.zipCode = offerSearch.zipCode;
    this.radius = offerSearch.radius;
    this.location = offerSearch.location;
    console.log('MapComponent.ngOnInit -> homeComponent miles=' + this.radius + ' zip=' + this.zipCode);
    this.mapService.init().subscribe((loaded) => {
      try {
        if (loaded) {
          if (this.zipCode == null)
            this.locationService.getLocationInfo().then(locationInfo => {
                this.initMap(locationInfo.latitude, locationInfo.longitude);
              },
              (error) => {
                console.log("MapComponent.ngOnInit failed getting current location");
                this.homeComponent.locationInfo.subscribe((locationInfo) => {
                  if (locationInfo === null)
                    this.initMap(40.7767502,-112.0856367);
                  else
                    this.initMap(locationInfo.latitude, locationInfo.longitude);
                })
              });
          else {
            let geocoder = new google.maps.Geocoder();
            console.log("MapComponent.init geocode...");
            geocoder.geocode({address: this.zipCode}, (results, status) => {
              console.log("geocode status: " + status);
              if (status == google.maps.GeocoderStatus.OK) {
                this.initMap(results[0].geometry.location.lat(), results[0].geometry.location.lng());
              }
            });
          }
        }
      } catch (e) {
        console.log("Error in MapComponent:");
        console.log(e);
      }
    });
  }

  initMap(lat: number, lng: number) {
    this.latitude = lat;
    this.longitude = lng;
    this.buildMap({lat, lng});
  }

  buildMap(center) {
    console.log(center);
    this.map = new google.maps.Map(
      document.getElementById('map') as HTMLElement,
      {
        disableDefaultUI: false,
        center: center,
        zoom: 11,
        minZoom: 9,
        maxZoom: 18,
        mapId: 'Offers',
        clickableIcons: false
      }
    );
    let originalOfferCount = this.homeComponent.getOffers().length;

    // for better perceived performance, render the map with whatever offers we have already loaded
    this.renderMap(center);

    // reload offers and if changed, re-render the map with the new offers
    this.homeComponent.reloadOffers();
    // TODO setInterval is 'smelly'. There is probably a cleaner way to do this, but I'm pressed for time.
    let offerPollInterval = setInterval(() => {
      console.log('interval...');
      let offerCount = this.homeComponent.getOffers().length;
      if (offerCount > 0) {
        if (offerCount != originalOfferCount) {
          this.renderMap(center);
        }
        clearInterval(offerPollInterval);
      }
    }, 500);
  }

  renderMap(center) {
    let bounds = new google.maps.LatLngBounds();
    let existingMarkers = this.map.markers;
    let offers: OfferInfo[] = this.homeComponent.getOffers();
    let offersWithAddress: OfferInfo[] = offers.filter(o => !o.onlineOnly && o.addresses.length > 0);

    if (!offersWithAddress || offersWithAddress.length == 0) {
      let position = center;
      let marker = new google.maps.Marker(
        {
          map: this.map,
          position: position,
          title: 'No offers found in search area'
        }
      );
      this.markers.push(marker);
      let content = '<td>No offers found in search area</td>';
      let info = new google.maps.InfoWindow({
        content: content,
        ariaLabel: 'No offers found in search area'
      });
      bounds.extend(marker.getPosition());
    }
    else {
      offersWithAddress.forEach(offer => {
        offer.addresses.forEach(address => {
          let position = {lat: address.latitude, lng: address.longitude};
          // TODO to reduce requests to map api, if marker is already in markers, then do nothing, as it should already be on the map.
          //  at the end we should clear old markers that were not part of the new search via "markers[n].setMap(null)"
          let marker = new google.maps.Marker(
            {
              map: this.map,
              position: position,
              title: offer.companyName,
              icon: "/assets/icon/wf-map-pin.svg"
            }
          );
          this.markers.push(marker);
          let content = '<td class="offer-info" *ngIf="selectedOffer">' +
            '<a href="/offer/' + offer.id + '">' +
            '  <table><tr>' +
            '  <td>' +
            '    <img class="tiny-logo" style="max-height:50px; max-width:100px; color:black;" src="' + offer.companyLogoUrl + '"/>' +
            '  </td>' +
            '  <td>' +
            '    <div style="color:black; font-weight: bold">' + offer.name + '</div>' +
            '    <div style="color:black">' + address.city + ' ' + this.calculateDistance(address) + ' mi</div>' +
            '    <div style="color:darkred">Tap to View Offer</div>' +
            '  </td>' +
            '  </tr></table>' +
            '</a>' +
            '</div>';
          let info = new google.maps.InfoWindow({
            content: content,
            ariaLabel: offer.companyName
          });
          marker.addListener("click", () => {
            if (this.currentInfo)
              this.currentInfo.close();
            info.open({anchor: marker, map: this.map});
            this.currentInfo = info;
            this.selectedOffer = offer;
            this.selectedLocation = address;
            this.selectedLocationDistance = this.calculateDistance(address);
          });
          bounds.extend(marker.getPosition());
        });
      });
    }
    this.map.fitBounds(bounds);
  }

  calculateDistance(address: AddressInfo): number {
    const distance = this.milesAwayPrecise(address);
    if (distance) {
      return distance > 1 ? Math.round(distance) : Math.round(distance * 10) / 10;
    }
    return null;
  }

  milesAwayPrecise(address: AddressInfo): number {
    if (this.hasMilesAway(address)) {
      const distance = LocationInfo.milesAway(
        { longitude: address.longitude, latitude: address.latitude },
        { longitude: this.longitude, latitude: this.latitude }
      );
      console.log(address.city + " distance: " + distance);
      return distance;
    }
    return null;
  }

  hasMilesAway(address: AddressInfo): boolean {
    return !!address.latitude && !!address.longitude && !!this.longitude && !!this.latitude;
  }
}
